import * as React from 'react';

import { getWeekEndingDate } from '@/modules/tsheets/helpers';

export function WeekEnding() {
  return <p>Week ending {getWeekEndingDate()}</p>;
}
